module.exports = __webpack_public_path__ + "static/media/Oswald-Regular.b299a657.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Oswald-Regular.ttf
// module id = ./src/fonts/Oswald-Regular.ttf
// module chunks = 2